import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { notificationsAtom } from '../../../atoms/Atoms';
import api from '../../../api/api';
import Form from '../../shared-components/form/Form';
import Input from '../../shared-components/form/Input';
import Button from '../../shared-components/buttons/Button';
import { H1 } from '../../shared-components/typography/Title';
import Subtitle from '../../shared-components/typography/Subtitle';


function Password() {
  const { t } = useTranslation();
  const history = useHistory();
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(`${t('valid_email_validation')}`)
        .required(`${t('required_field')}`),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      api
        .post(
          'users/me/reset',
          {
            Email: values.email,
          },
          null
        )
        .then((response) => {
          if (response.data.error) {
            setNotifications([
              ...notifications,
              {
                title: `${t('oops')}`,
                description:
                `${t('send_email_password')}`,
                error: true,
              },
            ]);
            setSubmitting(false);
          } else {
            setSubmitting(false);
            setNotifications([
              ...notifications,
              {
                title: `${t('alert')}`,
                description: response.data.message,
                error: false,
              },
            ]);
            history.push('/');
          }
        })
        .catch((error) => {
          setSubmitting(false);
          setNotifications([
            ...notifications,
            {
              title: `${t('oops')}`,
              description: `${t('send_email_password')} - ${error}`,
              error: true,
            },
          ]);
        });
    },
  });

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="flex flex-col justify-center py-6 px-4 md:px-0">
        <div className="sm:mx-auto sm:w-full sm:max-w-lg">
          <H1 text={t('recover_password')} />
          <Subtitle
            text={t('recover_password_prompt')}
          />
          <div className="w-full mb-2">
            <Form>
              <Input
                label={t('email')}
                type="email"
                name="email"
                id="email"
                placeholder={t('sample_email')}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={
                  formik.errors.email &&
                  formik.touched.email &&
                  formik.errors.email
                }
                className="col-span-2"
              />
            </Form>
            <Button
              text={t('cancel')}
              textColor="text-gray-400"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
              }}
              className="bg-gray-200 hover:bg-gray-300 w-20 mr-2"
            />
            <Button
              text={t('recover')}
              textColor="text-white"
              disabled={formik.isSubmitting}
              loading={formik.isSubmitting}
              onClick={formik.submitForm}
              loaderColor="bg-white"
              className="bg-emerald-400 hover:bg-emerald-500 w-20"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Password;
